import { render, staticRenderFns } from "./VirtualLetterPortraitPage.vue?vue&type=template&id=45c7b311"
import script from "./VirtualLetterPortraitPage.vue?vue&type=script&lang=js"
export * from "./VirtualLetterPortraitPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports